<template>
    <div class="page">
        <v-container :class="{'px-5': phoneOnly}">
            <div v-if="course" class="px-lg-3">
                <div v-if="course.enrolled" class="alerts">
                    <v-alert v-if="status === 'action-needed'" outlined color="error" type="info" text>
                        <div class="medium-text text--text">
                            <div class="multiline red--text text--darken-4 mb-2">
                                <span>{{course.enrollment.admin_comment}}</span>
                            </div>
                            <v-btn color="primary" small depressed @click="enrollDialog = true;">Edit your request</v-btn>
                        </div>
                    </v-alert>

                    <v-alert v-else-if="status !== 'approved'" color="text" text>
                        <div class="medium-text text--text">
                        <b>We've received your request to enroll in this course</b> <br>
                        We'll review your request and get back to you ASAP.
                        </div>
                    </v-alert>
                </div>
                <div class="d-flex flex-column flex-lg-row">
                    <div>
                        <v-card :flat="phoneOnly" :class="{'soft-shadow': pcOnly}" style="position: sticky; top: 15px;">
                            <v-card-text class="py-0" :class="{'px-0': phoneOnly}">
                                <div>
                                    <div class="mb-lg-10">
                                        <div>
                                            <v-img :width="pcOnly ? 500 : undefined" :height="pcOnly ? 300 : 205" :src="course.image_url" style="border-radius: 7px" />
                                            <v-btn v-if="course.video_url" color="primary" block class="mt-3" outlined depressed @click="videoDialog = true">
                                                <v-icon left>mdi-play-circle</v-icon>
                                                <span class="font-weight-semibold">Play video</span>
                                            </v-btn>
                                        </div>
                                        <div class="mt-4">
                                            <v-btn v-if="!course.enrolled || status === 'action-needed'" large depressed color="primary" block style="font-size: 1rem" @click="enrollDialog = true;">
                                                <strong v-if="status === 'action-needed'">
                                                    <v-icon class="me-1">mdi-square-edit-outline</v-icon>
                                                    <span>Edit</span>
                                                </strong>
                                                <template v-else>
                                                    <strong>
                                                        Enroll
                                                    </strong>
                                                    <v-icon color="secondary" right size="25" class="ms-2">mdi-chevron-right</v-icon>
                                                </template>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                    <div class="flex-grow-1 py-2 ps-lg-10">
                        <div>
                            <h1 v-if="pcOnly" class="course-title strong-text--text mb-2">
                                <span>{{course.name}}</span>
                            </h1>
                            <h2 v-else class="course-title strong-text--text mb-2">
                                <span>{{course.name}}</span>
                            </h2>
                            <div class="d-flex mb-3">
                                <v-chip color="primary" small label>{{course.category_name}}</v-chip>
                                <v-chip v-if="status && !approved" dark small label :color="handleStatus(status).color" class="ms-2">{{handleStatus(status).text}}</v-chip>
                            </div>
                            <template v-if="status === 'approved'">
                            <v-divider class="mb-4"></v-divider>
                            <div class="mb-4">
                                <v-list class="py-0 mb-3">
                                    <v-list-item class="px-0">
                                        <v-list-item-avatar size="48" rounded>
                                            <v-img :src="course.enrollment.teacher.avatar" />
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-subtitle style="line-height: 1.4!important;">Teacher</v-list-item-subtitle>
                                            <v-list-item-title class="text--text" style="line-height: 1.4!important;">{{course.enrollment.teacher.name}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                                <v-btn color="primary" outlined :to="{name: 'calendar'}">
                                    <v-icon left>mdi-calendar</v-icon>
                                    <span>Your Schedule</span>
                                </v-btn>
                            </div>


                            </template>
                            <v-divider class="mb-4"></v-divider>
                            <div v-if="course.description" class="description medium-text" v-html="parseText(course.description)"></div>
                        </div>
                        <template v-if="approved">
                            <!-- <v-card v-if="appData.enable_app_w" :flat="phoneOnly" class="px-3" :class="{'soft-shadow': pcOnly, 'transparent': phoneOnly}">
                                <v-card-title>Cancel Subscription</v-card-title>
                                <v-card-subtitle>
                                    If you canceled your subscription, all next classes of this course would be removed from your calender.
                                </v-card-subtitle>
                                <div v-if="course.finish_requested" class="px-4 pb-3">
                                    <v-alert text type="info" icon="mdi-book-remove-outline" dense color="error darken-1">
                                        <span class="medium-text font-weight-semibold">You requested to cancel this course, we'll approve your request ASAP.</span>
                                    </v-alert>
                                </div>
                                <v-card-actions class="pb-3 px-4">
                                    <v-btn :loading="finishing" :disabled="finishing || course.finish_requested" depressed color="red" :block="phoneOnly" class="white--text px-lg-3" @click="finishDialog = true">
                                        <v-icon left>mdi-book-cancel-outline</v-icon>
                                        Cancel Subscription
                                    </v-btn>
                                </v-card-actions>
                            </v-card> -->
                        </template>


                    </div>
                </div>

            </div>
        </v-container>

        <v-dialog v-model="enrollDialog" scrollable :fullscreen="phoneOnly" :fluid="phoneOnly" :transition="phoneOnly ? 'slide-y-transition' : 'slide-y-transition'" max-width="600">
            <v-card class="px-3" :class="{'soft-shadow': pcOnly}">
                <v-card-title class="d-flex justify-space-between mb-md-1" :class="{'mb-2': phoneOnly}">
                    <div>
                        <span>Enroll in {{ course.name }}</span>
                    </div>
                    <v-btn icon absolute top right @click="enrollDialog = false;">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <div>
                        <!-- <v-btn :disabled="editable" color="blue-grey" outlined :dark="!editable" depressed @click="allowEdit = true">
                            <v-icon size="20" left>mdi-pencil</v-icon>
                            <span>Edit</span>
                        </v-btn> -->
                    </div>
                </v-card-title>
                <v-card-subtitle v-if="!course.enrollment" class="mb-2">Select your preferred schedule</v-card-subtitle>
                <v-card-subtitle v-else class="mb-2">We're reviewing your request.</v-card-subtitle>
                <v-card-text>
                    <v-form>
                        <v-alert v-if="!course.enrolled" type="info" dense text class="medium-text" color="amber darken-3">
                            <span class="text--text">
                                Multiple options are welcomed.
                            </span>
                        </v-alert>
                        <v-row>
                            <v-col cols="12" lg="12">
                                <v-menu v-model="startDateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto" >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :disabled="!editable" filled v-model="startDate" label="Start Date" placeholder="Start date" readonly hide-details v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker :min="minStartDate" v-model="startDate" @input="startDateMenu = false" color="primary" landscape no-title></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <v-select :readonly="!editable" :items="courseDurationItems" v-model="classDuration" :menu-props="{offsetY: true}" label="Class Duration" filled hide-details>
                                    <template v-slot:item="{item}">
                                        <div>{{ item.text }}</div>
                                        <v-chip v-if="appData.enable_app_w" color="primary" small class="ms-2 px-2">{{ moneyFormat(item.price, true) }}  <span class="details--text"> / class</span></v-chip>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <v-select :readonly="!editable" :items="classesPerWeekItems" v-model="classesPerWeek" :disabled="!classDuration" filled :menu-props="{offsetY: true}" label="Classes per Week" hide-details>
                                    <template v-slot:item="{item}">
                                        <div>{{ item.text }}</div>
                                        <v-chip v-if="appData.enable_app_w" color="primary" small class="ms-2 px-2">{{ moneyFormat(item.price, true) }}  <span class="details--text"> / week</span></v-chip>
                                    </template>
                                </v-select>
                            </v-col>
                            <template v-for="(entry, i) in timeEntries">
                                <v-col cols="1" :key="'4-' + i" class="d-flex justify-start align-center">
                                    <div>
                                        <v-icon color="primary">mdi-clock</v-icon>
                                    </div>
                                </v-col>
                                <v-col cols="5" :key="'1-' + i">
                                    <v-select :dense="phoneOnly" :readonly="!editable" filled v-model="timeEntries[i]['day']" :items="preferredDaysItems" label="Day" placeholder="Choose Day" :menu-props="{offsetY: true}" hide-details></v-select>
                                </v-col>
                                <v-col cols="6" :key="'2-' + i">
                                    <time-input v-model="timeEntries[i]['from']" :dense="phoneOnly" hide-icon half-format :disabled="(!timeEntries[i]['day'] && timeEntries[i]['day'] !== 0) || !editable" filled label="Time" placeholder="Time" /> <!-- :max="timeEntries[i]['to']" -->
                                </v-col>
                                <!-- <v-col cols="3" :key="'3-' + i">
                                    <time-input v-model="timeEntries[i]['to']" :replaces="[['00:00', '23:59']]" :dense="phoneOnly" :hide-icon="phoneOnly" half-format :disabled="!timeEntries[i]['from'] || !editable" outlined label="To" placeholder="To Time" />
                                </v-col> -->
                            </template>
                            <v-col cols="12" class="py-0 mt-3 mb-5">
                                <v-btn :disabled="!editable" color="primary" dense small text @click="addTimeEntry" block outlined>
                                    <v-icon left class="me-1">mdi-plus-circle</v-icon>
                                    Add
                                </v-btn>
                            </v-col>

                            <v-col cols="12" class="py-1">
                                <v-textarea v-model="comment" :disabled="!editable" rows="4" no-resize filled label="Leave us a message (optional)" placeholder="Leave us a message (optional)" hide-details></v-textarea>
                            </v-col>
                        </v-row>
                        

                        <div class="actions mt-7">
                            <v-btn v-if="!course.enrolled" :loading="enrolling" block :disabled="enrolling" large depressed color="primary" style="min-width: 180px" @click="enrollCourse">
                                <span>Enroll</span>
                            </v-btn>
                            <v-btn v-else :loading="updating" :disabled="updating || !editable" :dark="!updating && editable" large block depressed color="primary" style="min-width: 180px" @click="updateEnrollment">
                                <span>Save</span>
                            </v-btn>
                        </div>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-if="course.video_url" transition="slide-y-transition" scrollable v-model="videoDialog" max-width="700" overlay-opacity="0.8" overlay-color="#000">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text class="pt-4">
                    <div class="mt-6">
                        <iframe v-if="course.video_url.search('youtube.com/embed') !== -1" style="width: 100%; border-radius: 12px;" :style="`min-height: ${phoneOnly ? 250 : 400}px`" :src="course.video_url" :title="course.name" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <video v-else controls style="width: 100%;" :style="`min-height: ${phoneOnly ? 250 : 300}px`">
                            <source :src="course.video_url" />
                        </video>
                    </div>
                    <v-btn icon absolute top right @click="videoDialog = false;">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>


        <v-dialog transition="slide-y-transition" v-model="finishDialog" max-width="375">
            <v-card>
                <v-card-title>Cancel Subscription Request</v-card-title>
                <v-card-text>
                    <div class="mb-6">
                        Are you sure that you want to cancel your subscription? You can enroll again later.
                    </div>

                    <div>
                        <v-textarea v-model="finishReason" outlined rows="4" placeholder="Reason of cancelation" no-resize hide-details></v-textarea>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="muted" @click="finishDialog = false">cancel</v-btn>
                    <v-btn text color="error" @click="finishCourse">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

// @ is an alias to /src

import {isEqual} from 'lodash'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import TimeInput from '@/components/custom/time-input'
export default {
    name: "Course",
    components: {
        TimeInput
    },
    data(){
        const d = new Date();
        d.setDate(d.getDate()+1); // min start_date is tomorrow

        const max = new Date();
        max.setFullYear(max.getFullYear()-3);
        return {
            course: null,
            courseMeta: null,
            timeEntries: [
                {day: '', from: '', to: ''},
                {day: '', from: '', to: ''},
                {day: '', from: '', to: ''},
            ],

            videoDialog: false,

            enrollDialog: false,

            loading: false,
            enrolling: false,
            startDateMenu: false,
            minStartDate: d.toISOString().substr(0, 10),
            
            classDuration: '',
            classesPerWeek: '',
            startDate: '',
            comment: '',

            menu: false,

            updating: false,
            finishing: false,
            allowEdit: false,

            preferredDaysItems: [
                {text: 'Saturday', value: 6},
                {text: 'Sunday', value: 0},
                {text: 'Monday', value: 1},
                {text: 'Tuesday', value: 2},
                {text: 'Wednesday', value: 3},
                {text: 'Thursday', value: 4},
                {text: 'Friday', value: 5},
            ],

            finishDialog: false,
            finishReason: '',
        }
    },
    computed: {
        id(){
            return this.$route.params.id;
        },
        editable(){
            if (this.status === 'action-needed' || !this.course.enrolled){
                return true;
            }
            return this.allowEdit;
        },
        approved(){
            // user enrollment approved
            return this.course.enrolled && this.course.enrollment.status === 'approved';
        },
        status(){
            return this.course.enrolled ? this.course.enrollment.status : null;
        },
        data(){
            return {
                class_duration: this.classDuration,
                weekly_classes: this.classesPerWeek,
                start_day: this.startDate,
                comment: this.comment,
                schedule: this.timeEntries.filter(item=>!!item.day || item.day === 0)
            }
        },
        courseDurationItems(){
            if (!this.courseMeta){
                return [];
            }
            const items = this.courseMeta.class_duration_items;
            return items.map(item=>{
                const hourlyPrice = this.course.enrollment && this.course.enrollment.hourly_price ? this.course.enrollment.hourly_price : this.course.hourly_price;
                const classPrice = hourlyPrice * (item.value/60); // hourly price * minutes/60
                return {
                    text: item.text,
                    price: classPrice,
                    value: item.value,
                }
            })
        },
        classesPerWeekItems(){
            let items = [
                {text: '1 class / week', value: 1},
                {text: '2 classes / week', value: 2},
                {text: '3 classes / week', value: 3},
                {text: '4 classes / week', value: 4},
                {text: '5 classes / week', value: 5},
                {text: '6 classes / week', value: 6},
            ];
            return items.map(item=>{
                const weeklyPrice = item.value * this.classPrice;
                if (this.appData.enable_app_w){
                    item.price = weeklyPrice
                }
                
                return item;
            });
        },
        classPrice(){
            const hourlyPrice = this.course.enrollment && this.course.enrollment.hourly_price ? this.course.enrollment.hourly_price : this.course.hourly_price;
            const classPrice = hourlyPrice * (this.classDuration/60); // hourly price * minutes/60

            return classPrice;
        },
        ...GlobalComputed
    },
    watch: {
        id(){
            this.loadData();
        },
        menu (val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
        classesPerWeek (val) {
            // if weekly classes changed, remove time entries
            if (this.timeEntries.length > val){
                this.timeEntries.splice(val);
            }else if (this.timeEntries.length < val){
                // add new time entries
                for (let i = this.timeEntries.length; i < val; i++){
                    this.timeEntries.push({day: '', from: '', to: ''});
                }
            }
        },
    },
    methods: {
        loadData(){
            if (!this.loading){
                this.loading = true;
                return this.$store.dispatch('getCourse', {id: this.id}).then(response=>{
                    this.course = response.data.data;
                    this.courseMeta = response.data.meta;
                    this.loading = false;

                    if (this.course.enrolled){
                        this.fillForm();
                    }

                }).catch((e)=>{
                    this.$router.push({name: 'courses'});
                    this.loading = false;
                    console.error(e);
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        enrollCourse(){
            if (!this.enrolling){
                if (this.validate()){
                    this.enrolling = true;
                    return this.$store.dispatch('enrollCourse', {id: this.id, data: this.data}).then(response=>{
                        this.course = response.data.data;
                        this.enrolling = false;
                        this.showMsg('We have received your request for enrollment. We will review it and get back to you as soon as possible.', 'success');
                        this.enrollDialog = false;
                        this.$store.dispatch('updateNotifications');
                        this.$store.dispatch('refreshUser').then(()=>{
                            window.setTimeout(()=>{
                                this.$router.push({name: 'home'});
                            }, 500);
                        });

                    }).catch(error=>{
                        this.enrolling = false;
                        if (error.response && error.response.status === 422){
                            // coming errors from backend
                            let errors = error.response.data.errors;
                            this.showMsg(errors[Object.keys(errors)[0]][0]);
                        }else{
                            this.showMsg('Error occurred during enrolling course', 'error');
                        }
                    })
                }
            }

        },
        updateEnrollment(){
            if (!this.updating){
                if (this.validate()){ /* && this.isFormUpdated() */
                    this.updating = true;
                    return this.$store.dispatch('updateCourseEnrollment', {id: this.id, data: this.data}).then(response=>{
                        this.updating = false;
                        this.course = response.data.data;
                        this.showMsg('Changes saved successfully', 'success');
                        this.enrollDialog = false;
                        this.allowEdit = false;
                    }).catch(error=>{
                        this.updating = false;
                        if (error.response && error.response.status === 422){
                            // coming errors from backend
                            let errors = error.response.data.errors;
                            this.showMsg(errors[Object.keys(errors)[0]][0]);
                        }else{
                            this.showMsg('Error occurred during submitting', 'error');
                        }
                    })
                }
            }

        },
        finishCourse(){
            if (!this.finishing){
                if (this.finishReason){
                    this.finishDialog = false;
                    this.finishing = true;
                    return this.$store.dispatch('finishEnrollment', {id: this.id, data: {reason: this.finishReason}}).then(response=>{
                        this.finishing = false;
                        // this.course = response.data.data;f
                        this.showMsg('Your request sent successfully', 'success');
                        this.$router.push({name: 'courses'});
                    }).catch(error=>{
                        this.finishing = false;
                        this.showMsg('Error occurred during finishing', 'error');
                    })
                }else{
                    this.showMsg('Please enter the reason.', 'warning');
                }
            }
        },
        isFormUpdated(){
            const enrollment = this.course.enrollment;
            if (enrollment){
                const newData = this.data,
                    data = Object.keys(newData).reduce((obj, key) => {obj[key] = enrollment[key]; return obj}, {});
                
                const updated = !isEqual(newData, data);
                if (!updated) this.showMsg('Please update enrollment form to resubmit');
                return updated;
            }
            return false;
        },
        fillForm(){
            if (this.course.enrollment){
                const enrollment = this.course.enrollment;
                this.classDuration = enrollment.class_duration;
                this.classesPerWeek = enrollment.weekly_classes;
                this.startDate = enrollment.start_day;
                this.comment = enrollment.comment;
                this.timeEntries = enrollment.schedule;
            }
        },
        validate(){
            const data = this.data;
            if (!data.class_duration || !data.weekly_classes || !data.start_day){
                this.showMsg('Required inputs cannot be empty', 'error');
                return false;
            }else if (data.schedule.length < data.weekly_classes){
                this.showMsg(`please add more Schedule times`, 'error');
                return false;
            }

            let timeValid = true;
            data.schedule.forEach(scheduleItem=>{
                if (!scheduleItem.from){
                    this.showMsg(`Time input is required`, 'error');
                    timeValid = false;
                }
            })
            if (!timeValid) return false;
            return true;
        },
        addTimeEntry(){
            this.timeEntries.push({day: '', from: '', to: ''});
        },
        removeTimeEntry(i){
            this.timeEntries.splice(i, 1);
        },
        save (date) {
            this.$refs.menu.save(date)
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        parseText(text){
            let html = this.escapeHtmlText(text);
            html = text.replaceAll(/\*\*.*?\*\*?/ig, match=>{
                return `<strong class="strong-text--text">${match.replaceAll('**', '')}</strong>`;
            }).replaceAll(/\#\#.*?\#\#?/ig, match=>{
                return `<h2 class="description-title primary--text">${match.replaceAll('##', '')}</h2>`;
            });

            html = this.urlify(html);
            return html
        },
        ...GlobalMethods
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
    .course-title{
        line-height: 2.1rem;
    }
    .description{
        white-space: pre-line;
        font-size: 0.9rem;
        line-height: 1.5rem;
    }
    .multiline{
        white-space: pre-line;
    }
    .description-title{
        font-weight: bold;
        font-size: 1.8rem;
    }
</style>
